/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_One_FrameInputs */

const en_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go forward one frame in the video`)
};

const fr_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancer d'une image dans la video`)
};

const de_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Video ein Bild vorwärts springen.`)
};

const it_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai avanti di un fotogramma nel video`)
};

const ru_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перемотайте видео на один кадр вперед.`)
};

const es_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar un fotograma en el vídeo`)
};

const zh_cn2_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频快进一帧。`)
};

const ja_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオを1フレーム進める`)
};

const hi_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में एक फ्रेम आगे बढ़ें`)
};

const pt_pt2_shortcut_keys_desc_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Desc_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avance um quadro no vídeo.`)
};

/**
* | output |
* | --- |
* | "Go forward one frame in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_one_frame = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "de") return de_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "it") return it_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "es") return es_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_forward_one_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_forward_one_frame(inputs)
	return en_shortcut_keys_desc_forward_one_frame(inputs)
});